import { FeeItem } from '../model/fee-item.model'

export const getExistingFee = (fees: FeeItem[], feeItem: FeeItem): FeeItem =>
  fees.find((f) => f.id == feeItem.id || f.id === feeItem.baseFeeId || f.id === feeItem?.baseFee?.id)
